module.exports = __webpack_public_path__ + "img/ic-gps-idle.05553337.svg";